import {charcoal} from '../../sass/base/_exports.sass';
import {SocialIgIcon} from '../../svg/SocialIgIcon';
import {SocialPinIcon} from '../../svg/SocialPinIcon';
import {SocialTTIcon} from '../../svg/SocialTTIcon';

export const SocialButtons = () => (
  <div className="footer__social-icons">
    <a
      href="https://www.instagram.com/evite/"
      title="Instagram"
      target="_blank"
      rel="noopener noreferrer"
      className="instagram"
      data-qa-id="footer_instagram"
    >
      <SocialIgIcon ratio={0.75} color={charcoal} />
    </a>
    <a
      href="https://www.tiktok.com/@evite"
      title="TikTok"
      target="_blank"
      rel="noopener noreferrer"
      className="tiktok"
      data-qa-id="footer_tiktok"
    >
      <SocialTTIcon ratio={0.75} />
    </a>
    <a
      href="https://www.pinterest.com/evite/"
      title="Pinterest"
      target="_blank"
      rel="noopener noreferrer"
      className="pinterest"
      data-qa-id="footer_pinterest"
    >
      <SocialPinIcon ratio={0.75} color={charcoal} />
    </a>
  </div>
);
